require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-lhv-kindlustus.json") })
        }
      }, "path---projects-lhv-kindlustus");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-lhv-kindlustus!./.cache/json/projects-lhv-kindlustus.json
// module id = 589
// module chunks = 231608221292675